export class DollarValueParameter {

    constructor($scope, $log) {
        this.$scope = $scope;
        this.$log = $log;
        $log.debug('mounting the DollarValueParameter component!')
    }

    $onInit = () => {
        this.$scope.parameter = this.parameter;
        this.$log.debug('finished mounting the DollarValueParameter component!')
    };

    static instance = {
        controller: ['$scope', '$log', DollarValueParameter],
        template: require('./dollarValueParameter.html'),
        bindings: {
            parameter: '<'
        }
    }
}